import * as React from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "components/common";
import HealthStatusIcon from "./HealthStatusIcon";
import { getStatusLabel } from "./healthStatusCopy";
import useExpansionCascade from "./useExpansionCascade";
import useTreeExpansion from "./useTreeExpansion";
import {
  ChevronSlot,
  StyledTree,
  TreeCountSuffix,
  TreeLabel,
  TreePane,
  TreeRow,
  TreeToggle
} from "./HealthModule.styles";
const HealthTreePane = ({ tree, treeData, lookup, root, viewMode }) => {
  const { t } = useTranslation("enterprise_license");
  useExpansionCascade(tree, lookup, root.id);
  useTreeExpansion(tree, root, viewMode);
  return /* @__PURE__ */ React.createElement(TreePane, null, /* @__PURE__ */ React.createElement(
    StyledTree,
    {
      "aria-label": t("health.tree.label"),
      data: treeData,
      tree,
      expandOnClick: false,
      selectOnClick: true,
      renderNode: ({ expanded, hasChildren, node, selected, elementProps }) => {
        const nodeProps = node.nodeProps;
        const isRootNode = node.value === root.id;
        const isExpandable = hasChildren && !isRootNode;
        const accessibleName = `${node.label}, ${getStatusLabel(nodeProps.status)}`;
        const toggleLabel = expanded ? t("health.tree.collapse", { label: node.label }) : t("health.tree.expand", { label: node.label });
        const handleRowClick = (event) => {
          var _a;
          (_a = elementProps.onClick) == null ? void 0 : _a.call(elementProps, event);
          if (!isExpandable) return;
          if (selected) {
            tree.toggleExpanded(node.value);
          } else {
            tree.expand(node.value);
          }
        };
        return /* @__PURE__ */ React.createElement(TreeRow, { ...elementProps, onClick: handleRowClick, $selected: selected, "aria-label": accessibleName }, /* @__PURE__ */ React.createElement(ChevronSlot, null, hasChildren && !isRootNode ? /* @__PURE__ */ React.createElement(
          TreeToggle,
          {
            type: "button",
            tabIndex: -1,
            "aria-expanded": expanded,
            "aria-label": toggleLabel,
            title: toggleLabel,
            onKeyDown: (event) => {
              if (event.key === " " || event.key === "Enter") event.stopPropagation();
            },
            onClick: (event) => {
              event.stopPropagation();
              tree.toggleExpanded(node.value);
            }
          },
          /* @__PURE__ */ React.createElement(Icon, { name: expanded ? "keyboard_arrow_down" : "keyboard_arrow_right", size: "sm" })
        ) : null), /* @__PURE__ */ React.createElement(HealthStatusIcon, { status: nodeProps.status, title: getStatusLabel(nodeProps.status) }), /* @__PURE__ */ React.createElement(TreeLabel, { $emphasized: hasChildren }, node.label), nodeProps.countSummary ? /* @__PURE__ */ React.createElement(TreeCountSuffix, null, "(", nodeProps.countSummary, ")") : null);
      }
    }
  ));
};
export default HealthTreePane;
